module.exports = __webpack_public_path__ + "static/media/card9.fea8b723.png";